import axiosInstance from "@/config/axios";
import { AUTH_KEY } from "@/constants/local-storage-key";

interface LoginData {
	userCode: string;
	password: string;
}

export const postlogin = async (data: LoginData) => {
	try {
		const response = await axiosInstance.post("/auth/sign-in-company", data);

		if (response.data) {
			localStorage.setItem(AUTH_KEY, JSON.stringify(response.data.data));
			localStorage.setItem(
				"companyId",
				JSON.stringify(response.data.data.companyId),
			);
			localStorage.setItem("userChatId", response.data.data.userChatId);
			localStorage.setItem(
				"accessToken",
				JSON.stringify(response.data.accessToken),
			);
		}

		return response.data;
	} catch (error) {
		console.error("Login error:", error);
		throw error;
	}
};
